<template>
  <v-footer class="footer text-center">
      <img src="../../assets/images/hypehive-logo.png" height="30" width="auto" class="">
      <div class="company-name">하이파이브 ㈜</div>
      <div class="copyright">&copy; {{ new Date().getFullYear() }} HypeHive. All rights reserved.</div>
  </v-footer>
</template>
<script setup>
</script>
<style scoped>
@import '../../assets/styles/mainLayout.scss';
</style>